import React, { Component } from 'react';

const CalaculatorResult = ({result}) => {

  return (
    <div className="result">
      <p>ITEMS &nbsp;  {result?.itemCounts.toLocaleString()}</p>
      <p style={{color:'green'}}>TOTAL AMOUNT &nbsp;  {result?.totalPurchased.toLocaleString()}</p>
    </div>
  )

}

export default CalaculatorResult;